import { gsap } from 'gsap';
function Animate(sprite, { duration = 1, speed = 1, ease = 'Cubic.easeIn', index, istemplate }) {
  if (sprite.text) {
    var finalCount = sprite.text;
    var totalDuration = duration * speed;
    let args = {
      sprite: sprite,
      totalDuration: totalDuration,
      finalCount: finalCount,
    };
    sprite.text = 0;
    var animation = gsap.to(sprite, {
      duration: duration * speed,
      ease: 'slow(0.3, 0.7, false)',
      paused: true,
      onUpdate: function (args) {
        let ratio = this.ratio;
        if (ratio > 0.9) {
          ratio = 1;
        }
        let count = parseInt(parseInt(args.finalCount) * this.ratio);
        args.sprite.text = count;
      },
      onUpdateParams: [args],
    });
    return animation;
  }
  var animation = gsap.to(sprite, {
    duration: duration * speed,
    ease: 'power3.out',
    paused: true,
  });
  return animation;
}
export default { Animate };
